/*Theme Styles to disable other content on map*/
const stylers = [
	{ invert_lightness: true },
	// { hue: "#ff003b" },
	{ hue: '#ffffff' },
	{ saturation: -100 },
	{ lightness: 100 },
];

export const theme = [
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers,
	},
	{
		featureType: 'landscape',
		stylers,
	},
	{
		featureType: 'road',
		stylers,
	},
	{
		featureType: 'administrative',
		stylers,
	},
	{
		featureType: 'poi',
		stylers,
	},
	{
		elementType: 'labels',
		stylers,
	},
];
